/* =========================================================
   Shop page ("Build your box"): rope, sea life, the pot's box tags,
   "View details" pop-outs and the "Add to box" buttons.
   Adding to the basket goes through window.LBCart (theme.js), which also
   gives starters and desserts the same delivery date as the box.
   ========================================================= */
(function () {
  var sea = document.querySelector('[data-byb-shop]');
  var modal = document.querySelector('[data-byb-modal]');
  var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;'}[c]; }); };

  // the visitor's chosen area (set by theme.js when they come through a location homepage)
  var LOC = null;
  try { var saved = JSON.parse(sessionStorage.getItem('lb-loc') || 'null'); if (saved && saved.key) LOC = saved.key; } catch (e) {}
  var forArea = function (areas) { areas = String(areas || '').split(',').filter(Boolean); return !LOC || !areas.length || areas.indexOf(LOC) > -1; };

  /* ---------- basket state ---------- */
  var isExtra = function (i) { var t = String(i.product_type || '').trim(); return /^(starter|dessert)s?$/i.test(t) || /main/i.test(t); };
  var cartNow = (window.LB && window.LB.cart) || {items: []};
  function showCart(c) {
    cartNow = c || cartNow;
    var inCart = {};
    (cartNow.items || []).forEach(function (i) { inCart[i.variant_id] = true; });
    document.querySelectorAll('[data-byb-add]').forEach(function (b) {
      var on = !!inCart[b.getAttribute('data-byb-add')];
      b.classList.toggle('on', on); b.textContent = on ? 'In your box ✓' : 'Add to box';
    });
    var n = (cartNow.items || []).filter(isExtra).reduce(function (a, i) { return a + i.quantity; }, 0);
    var tally = document.querySelector('[data-byb-tally]');
    if (tally) {
      tally.querySelector('[data-byb-count]').textContent = n + (n === 1 ? ' extra' : ' extras');
      tally.classList.toggle('show', n > 0);
    }
  }
  document.addEventListener('lb:cart', function (e) { showCart(e.detail); });

  function toggleAdd(btn) {
    var id = btn.getAttribute('data-byb-add'), cart = window.LBCart;
    if (!cart || btn.classList.contains('busy')) return Promise.resolve();
    btn.classList.add('busy');
    var job = btn.classList.contains('on') ? cart.remove(id) : cart.add(id);
    return job.then(showCart).catch(function (err) { alert(err && err.message ? err.message : 'Sorry, that didn\'t work. Please try again.'); })
      .then(function () { btn.classList.remove('busy'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-byb-add]');
    if (b && !b.closest('[data-byb-modal]')) { e.preventDefault(); toggleAdd(b); }
  });

  /* ---------- "View details" pop-out (shop and festive pages) ---------- */
  var lastFocus = null;
  function openDetail(o) {
    if (!modal) return;
    lastFocus = document.activeElement;
    var q = function (k) { return modal.querySelector('[data-byb-d="' + k + '"]'); };
    q('img').src = o.img; q('img').alt = o.name;
    q('tag').textContent = o.tag || ''; q('name').textContent = o.name; q('price').textContent = o.price || '';
    q('body').innerHTML = o.body || '';
    var act = q('act');
    act.classList.remove('on');
    if (o.addBtn) {
      act.textContent = o.addBtn.classList.contains('on') ? 'In your box ✓' : 'Add to box';
      act.classList.toggle('on', o.addBtn.classList.contains('on'));
      act.onclick = function () { toggleAdd(o.addBtn).then(function () { act.textContent = o.addBtn.textContent; act.classList.toggle('on', o.addBtn.classList.contains('on')); }); };
      act.hidden = false;
    } else if (o.url) {
      act.textContent = o.go || 'Choose your date';
      act.onclick = function () { location.href = o.url; };
      act.hidden = false;
    } else act.hidden = true;
    modal.hidden = false; document.documentElement.style.overflow = 'hidden';
    modal.querySelector('.byb-detail-x').focus();
  }
  function closeDetail() { if (!modal) return; modal.hidden = true; document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus(); }
  if (modal) {
    modal.addEventListener('click', function (e) { if (e.target.closest('[data-byb-close]')) closeDetail(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeDetail(); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-byb-detail]'); if (!a) return;
    var card = a.closest('.byb-card'); if (!card) return;
    e.preventDefault();
    var img = card.querySelector('.byb-pic img'), more = card.querySelector('.byb-more'), go = card.querySelector('[data-byb-go]');
    openDetail({img: img ? (img.getAttribute('data-big') || img.src) : '', tag: card.querySelector('.byb-tag').textContent,
      name: card.querySelector('h3').textContent.trim(), price: card.querySelector('.byb-price').textContent,
      body: more && more.innerHTML.trim() ? more.innerHTML : '<p>' + esc((card.querySelector('.byb-txt p') || {}).textContent) + '</p>',
      addBtn: card.querySelector('[data-byb-add]'), url: go ? go.getAttribute('href') : a.getAttribute('href'), go: 'Choose your date'});
  });

  showCart();
  if (!sea) return;   // everything below is only for the Shop page

  /* ---------- only show what's sold in the visitor's area; alternate sides on the rope ---------- */
  var line = sea.querySelector('.byb-line');
  if (line) {
    line.querySelectorAll('.byb-catch').forEach(function (c) { if (!forArea(c.getAttribute('data-areas'))) c.remove(); });
    // drop a depth marker if nothing hangs under it any more
    line.querySelectorAll('.byb-depth').forEach(function (d) { var n = d.nextElementSibling; if (!n || !n.classList.contains('byb-catch')) d.remove(); });
    line.querySelectorAll('.byb-catch').forEach(function (c, i) { c.classList.add(i % 2 ? 'r' : 'l'); });
  }

  /* ---------- the boxes in the pot ---------- */
  var boxes = [];
  sea.querySelectorAll('[data-byb-boxdata]').forEach(function (d) { boxes.push({title: d.dataset.title, type: d.dataset.type, img: d.dataset.img, from: d.dataset.from, url: d.dataset.url, areas: d.dataset.areas, body: d.innerHTML}); });
  boxes = boxes.filter(function (b) { return forArea(b.areas); });
  // The Lobster Box (product type "Signature") always sits in the pot first
  boxes.sort(function (a, b) { return (/signature/i.test(b.type) ? 1 : 0) - (/signature/i.test(a.type) ? 1 : 0); });
  var potBox = sea.querySelector('[data-byb-box]'), tags = sea.querySelector('[data-byb-tags]'), current = 0;
  var standard = (sea.querySelector('.byb-tags-note') || {}).textContent;
  standard = standard ? standard.replace(/^Every box comes\s*/i, '') : 'standard for two';
  function setBox(i, animate) {
    var x = boxes[i]; if (!x || !potBox) return;
    current = i;
    var fill = function () {
      var b = function (k) { return sea.querySelector('[data-byb-b="' + k + '"]'); };
      b('img').src = x.img; b('img').alt = x.title; b('type').textContent = x.type; b('title').textContent = x.title;
      b('from').textContent = 'From ' + x.from + ' · ' + standard; b('url').href = x.url;      potBox.classList.remove('swap');
    };
    if (animate) { potBox.classList.add('swap'); setTimeout(fill, 450); } else fill();
    if (tags) tags.querySelectorAll('button').forEach(function (t, j) { t.classList.toggle('on', j === i); });
  }
  if (tags) {
    if (boxes.length < 2) { tags.remove(); sea.querySelectorAll('.byb-plate-kicker,.byb-plate-rule').forEach(function (e) { e.remove(); }); }
    else {
      tags.innerHTML = boxes.map(function (b, i) { return '<button type="button" data-i="' + i + '">' + esc(b.title) + '</button>'; }).join('');
      tags.addEventListener('click', function (e) { var t = e.target.closest('button'); if (t && +t.dataset.i !== current) setBox(+t.dataset.i, true); });
      tags = sea.querySelector('[data-byb-tags]');
    }
  }
  if (boxes.length) setBox(0, false);
  sea.querySelectorAll('[data-byb-boxmore]').forEach(function (more) { more.addEventListener('click', function () {
    var x = boxes[current]; if (!x) return;
    openDetail({img: x.img, tag: x.type, name: x.title, price: 'From ' + x.from + ' · ' + standard, body: x.body, url: x.url, go: 'Choose your date'});
  }); });

  /* ---------- the rope ---------- */
  var buoy = sea.querySelector('[data-byb-buoy]'), pot = sea.querySelector('[data-byb-pot]'), svg = sea.querySelector('[data-byb-rope]');
  var paths = svg ? [].slice.call(svg.querySelectorAll('path')) : [], r1 = paths[0];
  var len = 0, firstLen = 0, potScroll = 1;
  function layout() {
    if (!buoy || !pot || !r1) return;
    var s = sea.getBoundingClientRect(), b = buoy.getBoundingClientRect(), p = pot.getBoundingClientRect();
    var phone = window.innerWidth <= 720;
    var x0 = b.left + b.width / 2 - s.left, y0 = b.top - s.top + b.height * (306 / 330);
    // the rope ties on to the ring at the top of the creel's bridle
    var ring = sea.querySelector('[data-byb-ring]'), rr = ring ? ring.getBoundingClientRect() : null;
    var x1 = rr ? rr.left + rr.width / 2 - s.left : p.left + p.width / 2 - s.left, y1 = rr ? rr.top - s.top + 2 : p.top - s.top - 10;
    svg.setAttribute('height', s.height); svg.setAttribute('viewBox', '0 0 ' + s.width + ' ' + s.height);
    var knots = [].slice.call(sea.querySelectorAll('.byb-catch .byb-knot'));
    var pts = [[x0, y0]];
    if (phone && knots.length) {
      knots.forEach(function (k) { var r = k.getBoundingClientRect(); pts.push([r.left + r.width / 2 - s.left, r.top + r.height / 2 - s.top]); });
    } else {
      var lineX = s.width / 2, n = 30;
      for (var i = 1; i < n; i++) { var t = i / n; pts.push([lineX + Math.sin(t * Math.PI * 5) * 12 * Math.sin(t * Math.PI), y0 + (y1 - y0) * t]); }
    }
    pts.push([x1, y1]);
    var d = 'M' + pts[0][0] + ' ' + pts[0][1];
    for (var j = 0; j < pts.length - 1; j++) {
      var q0 = pts[j - 1] || pts[j], q1 = pts[j], q2 = pts[j + 1], q3 = pts[j + 2] || q2;
      d += ' C' + (q1[0] + (q2[0] - q0[0]) / 6).toFixed(1) + ' ' + (q1[1] + (q2[1] - q0[1]) / 6).toFixed(1) + ' ' +
           (q2[0] - (q3[0] - q1[0]) / 6).toFixed(1) + ' ' + (q2[1] - (q3[1] - q1[1]) / 6).toFixed(1) + ' ' + q2[0].toFixed(1) + ' ' + q2[1].toFixed(1);
    }
    paths.forEach(function (pa) { pa.setAttribute('d', d); });
    len = r1.getTotalLength();
    // the rope already reaches the first item when the page opens
    firstLen = 0;
    if (knots.length) {
      var k = knots[0].getBoundingClientRect(), ky = k.top + k.height / 2 - s.top, lo = 0, hi = len;
      for (var m = 0; m < 24; m++) { var mid = (lo + hi) / 2; if (r1.getPointAtLength(mid).y < ky) lo = mid; else hi = mid; }
      firstLen = lo;
    } else firstLen = Math.min(len, 160);
    potScroll = Math.max(1, p.top + window.scrollY - window.innerHeight * .45);
    paint();
  }
  function paint() {
    if (!r1 || !len) return;
    var prog = Math.min(1, Math.max(0, window.scrollY / potScroll));
    var end = r1.getPointAtLength(firstLen + (len - firstLen) * prog).y;
    paths.forEach(function (pa) { var bb = pa.getBBox(); pa.style.clipPath = 'inset(0 0 ' + Math.max(0, bb.y + bb.height - end) + 'px 0)'; });
    sea.querySelectorAll('.byb-catch').forEach(function (c) { if (c.getBoundingClientRect().top < window.innerHeight * .82) c.classList.add('in'); });
  }

  /* ---------- bubbles ---------- */
  var bub = sea.querySelector('[data-byb-bubbles]');
  for (var i = 0; bub && i < 10; i++) {
    var e = document.createElement('span'), sz = 3 + Math.random() * 6;
    e.style.left = Math.random() * 100 + '%'; e.style.width = e.style.height = sz + 'px';
    e.style.animationDuration = 12 + Math.random() * 12 + 's'; e.style.animationDelay = -Math.random() * 24 + 's';
    bub.appendChild(e);
  }

  /* ---------- sea life: fish dart when tapped, starfish and shells can be flicked ---------- */
  var life = sea.querySelector('[data-byb-life]'), critters = [], pointer = {x: -999, y: -999};
  var specs = [
    {src: sea.dataset.fish, type: 'fish', w: 180, at: .27, x: .12, speed: .7},
    {src: sea.dataset.fish, type: 'fish', w: 120, at: .47, x: .75, speed: 1},
    {src: sea.dataset.fish, type: 'fish', w: 150, at: .66, x: .3, speed: .6},
    {src: sea.dataset.starfish, type: 'drift', w: 120, at: .36, x: .88},
    {src: sea.dataset.brittlestar, type: 'drift', w: 95, at: .56, x: .05},
    {src: sea.dataset.scallop, type: 'drift', w: 64, at: .9, x: .14}
  ];
  if (life) specs.forEach(function (sp, i) {
    if (!sp.src) return;
    var img = new Image(); img.src = sp.src; img.alt = ''; img.draggable = false; img.className = sp.type;
    var w = window.innerWidth <= 720 ? sp.w * .6 : sp.w;
    img.style.width = w + 'px'; life.appendChild(img);
    var c = {el: img, type: sp.type, w: w, x: sp.x * (sea.clientWidth - w), y: sp.at * sea.clientHeight, baseY: sp.at, vx: 0, vy: 0,
      dir: i % 2 ? -1 : 1, speed: sp.speed || 0, boost: 0, phase: Math.random() * 6, rot: Math.random() * 360, vr: 0, held: false};
    critters.push(c);
    if (c.type === 'fish') {
      img.addEventListener('pointerdown', function (ev) { ev.preventDefault(); c.dir = Math.random() < .5 ? -1 : 1; c.boost = 7; c.vy = (Math.random() - .5) * 5; });
    } else {
      var last = null;
      img.addEventListener('pointerdown', function (ev) { ev.preventDefault(); img.setPointerCapture(ev.pointerId); c.held = true; last = {x: ev.clientX, y: ev.clientY, t: performance.now()}; c.vx = c.vy = 0; });
      img.addEventListener('pointermove', function (ev) {
        if (!c.held) return;
        var now = performance.now(), dt = Math.max(16, now - last.t);
        c.x += ev.clientX - last.x; c.y += ev.clientY - last.y;
        c.vx = (ev.clientX - last.x) / dt * 16; c.vy = (ev.clientY - last.y) / dt * 16;
        last = {x: ev.clientX, y: ev.clientY, t: now};
      });
      var drop = function () { if (!c.held) return; c.held = false; c.vr = c.vx * .4; };
      img.addEventListener('pointerup', drop); img.addEventListener('pointercancel', drop);
    }
  });
  sea.addEventListener('pointermove', function (ev) { var r = sea.getBoundingClientRect(); pointer.x = ev.clientX - r.left; pointer.y = ev.clientY - r.top; });
  sea.addEventListener('pointerleave', function () { pointer.x = pointer.y = -999; });
  function tick(t) {
    var W = sea.clientWidth, H = sea.clientHeight, top0 = parseFloat(getComputedStyle(sea).getPropertyValue('--wl')) + 140;
    critters.forEach(function (c) {
      var h = c.el.offsetHeight || c.w * .6;
      if (c.type === 'fish') {
        var dx = c.x + c.w / 2 - pointer.x, dy = c.y + h / 2 - pointer.y, d = Math.sqrt(dx * dx + dy * dy);
        if (d < 140) { c.dir = dx > 0 ? 1 : -1; c.boost = Math.max(c.boost, 4); c.vy += dy / d * .3; }
        c.boost *= .965; c.vy *= .94; c.x += c.dir * (c.speed + c.boost); c.phase += .025;
        c.y += c.vy + (c.baseY * H - c.y) * .01 + Math.sin(c.phase) * .3;
        if (c.x > W - c.w * .3) c.dir = -1; if (c.x < -c.w * .7) c.dir = 1;
        c.el.style.transform = 'translate(' + c.x + 'px,' + c.y + 'px) scaleX(' + c.dir + ') rotate(' + (Math.sin(c.phase * 2) * 2.5) + 'deg)';
      } else {
        if (!c.held) {
          c.x += c.vx; c.y += c.vy; c.vx *= .95; c.vy *= .95; c.rot += c.vr; c.vr *= .985;
          if (c.x < 0) { c.x = 0; c.vx = -c.vx * .6; } if (c.x > W - c.w) { c.x = W - c.w; c.vx = -c.vx * .6; }
          if (c.y < top0) { c.y = top0; c.vy = -c.vy * .6; } if (c.y > H - h - 40) { c.y = H - h - 40; c.vy = -c.vy * .4; }
          c.rot += Math.sin(t / 1100 + c.phase) * .04;
        }
        c.el.style.transform = 'translate(' + c.x + 'px,' + c.y + 'px) rotate(' + c.rot + 'deg)';
      }
    });
    if (!still) requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  window.addEventListener('scroll', paint, {passive: true});
  window.addEventListener('resize', layout);
  window.addEventListener('load', layout);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(layout);
  sea.querySelectorAll('img').forEach(function (im) { if (!im.complete) im.addEventListener('load', layout); });
  layout();
})();
